import * as CryptoJS from 'crypto-js';

export let config: any = {
  baseUrl: '',
  baseEndpoint: '',
  key: ''
};

export function setConfig(newConfig: any) {
  config = newConfig;
  return config;
}



// WEBPACK FOOTER //
// /payu/microservice/multichannelportal/src/config/config.ts